import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const TicketDesk = lazy(() => import("../components/TicketDesk"));

const ticketDesk: RouteObject = {
  path: "/tickets",
  element: <TicketDesk />,
};

export default ticketDesk;
